import { render } from "./Bitacora-App.vue?vue&type=template&id=47a3b148&scoped=true"
import script from "./Bitacora-App.vue?vue&type=script&lang=js"
export * from "./Bitacora-App.vue?vue&type=script&lang=js"

import "./Bitacora-App.vue?vue&type=style&index=0&id=47a3b148&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a3b148"]])

export default __exports__